<template>
  <div>
    <v-chip
      v-if="isFilePresent"
      :href="file.url"
      close
      large
      style="max-width: 60%"
      @click:close="file = null"
      target="_blank"
      class="rounded-xl"
      x-small
    >
      <v-icon small class="mr-4">fa fa-file</v-icon>
      <div class="text-truncate" style="max-width: 335px">{{file.filename}}</div>
    </v-chip>

    <div v-else @drop="dropFile">
      <v-file-input
        outlined
        chips
        :clearable="false"
        clear-icon="fa fa-times"
        v-model="file"
        :accept="allowedTypes"
        :color="$store.state.achievement.side_color"
        placeholder="Прикрепите файл (pdf, jpeg, png)"
        :hint="descriptionKind"
        label="Файл*"
        class="rounded-xl"
        show-size
        truncate-length="50"
        :rules="achievementFileRules"
        dense
      >
      </v-file-input>
    </div>

  </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import _ from "lodash";

const {mapFields} = createHelpers({
  getterType: 'achievement/getPayloadAchievement',
  mutationType: 'achievement/updatePayloadAchievement',
});

export default {
  name: "TheAchievementFileInput",

  data() {
    return {
      allowedTypes: ".jpg, .jpeg, .png, .pdf",
      achievementFileRules: [
        v=> !!v || 'Обязательное поле.',
        v => (v && v.size <= 2048 * 1024) || 'Размер файла должен быть не более 2MB.',
        v => {
          if (!v) return true;
          const allowedFormats = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
          return allowedFormats.includes(v.type) || 'Доступны только PDF, PNG и JPEG файлы.';
        }
      ],
    };
  },

  props: {
    achievementKind: Object,
  },

  computed: {
    ...mapFields([
      'file',
    ]),

    isFilePresent() {
      return !_.isNil(this.file?.url);
    },

    descriptionKind() {
      if (_.isNil(this.achievementKind)) return ""
      return this.achievementKind.description;
    },

  },

  methods: {
    dropFile(e) {
      e.preventDefault();
      if (_.isNil(this.file)) {
        this.achievement.file = null;
        return this.file = e.dataTransfer.files[0];
      }
      return this.file = e.dataTransfer.files[0];
    },

    removeFile() {
      this.file = null;
    },
  },

}
</script>

<style scoped>

</style>